import { useCallback, useState } from 'react';

export default function useBooleanState(initialValue = false) {
  const [value, setValue] = useState(initialValue);

  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue((prev) => !prev), []);

  return {
    value,
    setTrue,
    setFalse,
    toggle,
  };
}
